export function setMemberships (state, { memberships }) {
	state.memberships = [ ...memberships ];
}
